import { blendColors, normalizeSrgbColorToHex } from '@wix/a11y-rules';
import { isNotOptional } from '@wix/seo-common-core';
import Color from 'color';
export const getUpdatedColorContrastElementsFromState = (elements, globalSectionRuleState) => {
  const passedElementsWithState = [];
  const failedElementsWithState = [];
  elements.forEach(el => {
    var _el$affectingAncestor;
    const globalEl = globalSectionRuleState == null ? void 0 : globalSectionRuleState.get(el.elementId);
    el.affectingAncestors = (_el$affectingAncestor = el.affectingAncestors) == null ? void 0 : _el$affectingAncestor.map(_ref => {
      var _globalSectionRuleSta;
      let [id, anc, className] = _ref;
      return [id, {
        ...anc,
        bgColor: (globalSectionRuleState == null || (_globalSectionRuleSta = globalSectionRuleState.get(id)) == null ? void 0 : _globalSectionRuleSta.bgColor) ?? anc.bgColor
      }, className];
    });
    if (globalEl) {
      var _el$affectingAncestor2;
      el.bgColor = (globalEl == null ? void 0 : globalEl.bgColor) ?? el.bgColor;
      el.textColor = (globalEl == null ? void 0 : globalEl.textColor) ?? el.textColor;
      const blendedBgColor = blendColors(((_el$affectingAncestor2 = el.affectingAncestors) == null ? void 0 : _el$affectingAncestor2.map(_ref2 => {
        let [, {
          bgColor,
          bgAlpha
        }] = _ref2;
        const color = new Color(normalizeSrgbColorToHex(bgColor) ?? bgColor);
        return isNotOptional(bgAlpha) ? color.alpha(bgAlpha) : color;
      })) ?? []);
      const currentContrastRatio = new Color(normalizeSrgbColorToHex(el.textColor) ?? el.textColor).contrast(blendedBgColor);
      el.isValid = el.isValid || globalEl.isSkippedColorContrastElement || currentContrastRatio >= el.minimalRatio;
    }
    if (el.isValid) {
      passedElementsWithState.push(el);
    } else {
      failedElementsWithState.push(el);
    }
  });
  return {
    failedElementsWithState,
    passedElementsWithState
  };
};
//# sourceMappingURL=get-updated-color-contrast-elements-from-state.js.map